<template>
  <div class="page-container">
    <AppSidebar />

    <div class="main-content">
      <div class="static-page">
        <div class="page-header">
          <h1>问题投稿</h1>
        </div>

        <div class="content-container">
          <div class="intro-text">
            <p>感谢您对我们网站的关注与支持！如果您在使用过程中遇到任何问题，或者有好的建议和意见，欢迎通过以下方式向我们反馈。我们会认真对待每一条反馈，并尽快给予答复。</p>
          </div>

          <div class="feedback-section">
            <h2>反馈类型</h2>
            <div class="feedback-types">
              <div class="type-card">
                <div class="type-icon bug-icon">🐛</div>
                <h3>Bug 反馈</h3>
                <p>发现功能异常、页面错误、显示问题等</p>
              </div>
              <div class="type-card">
                <div class="type-icon suggestion-icon">💡</div>
                <h3>功能建议</h3>
                <p>对现有功能的改进建议或新功能需求</p>
              </div>
              <div class="type-card">
                <div class="type-icon content-icon">📝</div>
                <h3>内容问题</h3>
                <p>漫画内容错误、缺失章节、翻译问题等</p>
              </div>
              <div class="type-card">
                <div class="type-icon other-icon">💬</div>
                <h3>其他反馈</h3>
                <p>任何其他意见和建议</p>
              </div>
            </div>
          </div>

          <div class="contact-section">
            <h2>联系方式</h2>
            <div class="contact-methods">
              <div class="contact-item">
                <div class="contact-icon">📧</div>
                <div class="contact-info">
                  <h4>电子邮箱</h4>
                  <p>wudongjian@huashi.tv</p>
                  <span class="contact-tip">推荐使用，我们会在1-3个工作日内回复</span>
                </div>
              </div>
              <div class="contact-item">
                <div class="contact-icon">📞</div>
                <div class="contact-info">
                  <h4>联系电话</h4>
                  <p>13641239621</p>
                  <span class="contact-tip">工作时间：周一至周五 9:00-18:00</span>
                </div>
              </div>
              <div class="contact-item">
                <div class="contact-icon">📍</div>
                <div class="contact-info">
                  <h4>公司地址</h4>
                  <p>湖北省武汉市洪山区雄楚大街452号保利蓝海郡G6栋1单元20层3室-2</p>
                  <span class="contact-tip">欢迎来访，请提前预约</span>
                </div>
              </div>
            </div>
          </div>

          <div class="tips-section">
            <h2>反馈建议</h2>
            <div class="tips-content">
              <p>为了帮助我们更快速准确地处理您的问题，建议您在反馈时提供以下信息：</p>
              <ul>
                <li><strong>问题描述：</strong>详细描述遇到的问题或您的建议</li>
                <li><strong>复现步骤：</strong>如果是Bug，请告诉我们如何重现该问题</li>
                <li><strong>使用环境：</strong>操作系统、浏览器类型和版本</li>
                <li><strong>截图或录屏：</strong>如果可能，请提供相关的截图或录屏</li>
                <li><strong>联系方式：</strong>留下您的邮箱或手机号，方便我们与您沟通</li>
              </ul>
            </div>
          </div>

          <div class="promise-section">
            <h2>我们的承诺</h2>
            <div class="promise-grid">
              <div class="promise-item">
                <div class="promise-icon">⚡</div>
                <h4>快速响应</h4>
                <p>1-3个工作日内回复</p>
              </div>
              <div class="promise-item">
                <div class="promise-icon">🔒</div>
                <h4>隐私保护</h4>
                <p>您的信息将被严格保密</p>
              </div>
              <div class="promise-item">
                <div class="promise-icon">✅</div>
                <h4>认真对待</h4>
                <p>每条反馈都会被记录和跟进</p>
              </div>
              <div class="promise-item">
                <div class="promise-icon">🎁</div>
                <h4>奖励机制</h4>
                <p>有价值的建议会获得奖励</p>
              </div>
            </div>
          </div>

          <div class="thank-you">
            <p>再次感谢您的反馈！您的意见是我们不断改进的动力。</p>
          </div>
        </div>
      </div>

      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppSidebar from '@/components/layout/Sidebar.vue';
import AppFooter from '@/components/layout/Footer.vue';

export default {
  name: 'FeedbackPage',
  components: {
    AppSidebar,
    AppFooter
  },
  mounted() {
    document.title = '问题投稿 - 武汉天冉网络科技有限公司';
  }
};
</script>

<style scoped>
.page-container {
  display: flex;
  min-height: 100vh;
  background-color: #f5f6fa;
}

.main-content {
  flex: 1;
  margin-left: 200px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.static-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  flex: 1;
  width: 100%;
}

.page-header {
  text-align: center;
  margin-bottom: 40px;
}

.page-header h1 {
  font-size: 30px;
  color: #333;
  margin-bottom: 10px;
  font-weight: 600;
  position: relative;
  display: inline-block;
  padding-bottom: 15px;
}

.page-header h1:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #ff6b81, #ff9eb6);
  border-radius: 3px;
}

.content-container {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.08);
}

.intro-text {
  line-height: 1.8;
  color: #666;
  font-size: 16px;
  margin-bottom: 30px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #ff6b81;
}

.feedback-section,
.contact-section,
.tips-section,
.promise-section {
  margin-bottom: 40px;
}

.feedback-section h2,
.contact-section h2,
.tips-section h2,
.promise-section h2 {
  font-size: 22px;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f0f0;
}

.feedback-types {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 20px;
}

.type-card {
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  text-align: center;
  transition: all 0.3s;
}

.type-card:hover {
  border-color: #ff6b81;
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(255, 107, 129, 0.2);
}

.type-icon {
  font-size: 48px;
  margin-bottom: 10px;
}

.type-card h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 8px;
}

.type-card p {
  font-size: 14px;
  color: #999;
  line-height: 1.5;
}

.contact-methods {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 10px;
  transition: all 0.3s;
}

.contact-item:hover {
  background: #fff0f3;
}

.contact-icon {
  font-size: 36px;
  margin-right: 20px;
}

.contact-info h4 {
  font-size: 18px;
  color: #333;
  margin-bottom: 5px;
}

.contact-info p {
  font-size: 16px;
  color: #ff6b81;
  margin-bottom: 5px;
  font-weight: 500;
}

.contact-tip {
  font-size: 13px;
  color: #999;
}

.tips-content {
  line-height: 1.8;
  color: #444;
  font-size: 15px;
  padding: 20px;
  background: #fffaf0;
  border-radius: 8px;
}

.tips-content p {
  margin-bottom: 15px;
}

.tips-content ul {
  list-style: none;
  padding-left: 0;
}

.tips-content li {
  margin-bottom: 12px;
  padding-left: 20px;
  position: relative;
}

.tips-content li:before {
  content: "▪";
  position: absolute;
  left: 0;
  color: #ff6b81;
  font-weight: bold;
}

.tips-content strong {
  color: #ff6b81;
}

.promise-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 20px;
}

.promise-item {
  text-align: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 10px;
  transition: all 0.3s;
}

.promise-item:hover {
  background: linear-gradient(135deg, #fff0f3, #f8f9fa);
  transform: translateY(-3px);
}

.promise-icon {
  font-size: 36px;
  margin-bottom: 10px;
}

.promise-item h4 {
  font-size: 16px;
  color: #333;
  margin-bottom: 8px;
}

.promise-item p {
  font-size: 13px;
  color: #999;
}

.thank-you {
  text-align: center;
  padding: 30px;
  background: linear-gradient(135deg, #fff0f3, #f8f9fa);
  border-radius: 10px;
  margin-top: 20px;
}

.thank-you p {
  font-size: 16px;
  color: #ff6b81;
  font-weight: 500;
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
  }

  .static-page {
    padding: 20px 15px;
  }

  .content-container {
    padding: 20px;
  }

  .feedback-types,
  .promise-grid {
    grid-template-columns: 1fr;
  }

  .contact-item {
    flex-direction: column;
  }

  .contact-icon {
    margin-right: 0;
    margin-bottom: 10px;
  }
}
</style>
